export default class SalesChannelsConfig {
    constructor(web, mostrador, salon){
        console.log('web: ', web)
        console.log('mostrador: ', mostrador)
        console.log('salon: ', salon)
        this.web = {
            enabled: web?.enabled || false,
            modes: web?.modes || []
        }
        this.mostrador = {
            enabled: mostrador?.enabled || false,
            modes:  mostrador?.modes || []
        }
        this.salon = {
            enabled: salon?.enabled || false
        }
    }

    updateEnabledWeb(value){
        this.web.enabled = value
    }
    updateModesWeb(value){
        this.web.modes = value
    }

    updateEnabledMostrador(value){
        this.mostrador.enabled = value
    }
    updateModesMostrador(value){
        this.mostrador.modes = value
    }

    updateEnabledSalon(value){
        this.salon.enabled = value
    }
}